import React, { FC } from 'react';
import styled from 'styled-components';
import { mediaQueries, size, typography, Button } from '@everlywell/leaves';
import { Link } from 'gatsby';

interface AddToCart {
  title: string;
  price: string;
  slug: string;
  isUpgrade: boolean;
  onClick: () => void;
}

const ProductTitle = styled(Link)`
  ${typography.buttonTextSmall}
  text-decoration: none;
  font-weight: normal;
  margin: ${size.sm}px 0;
  ${mediaQueries.forTabletHorizontalUp} {
    margin-top: 4px 0;
  }
`;

const ProductPrice = styled.div`
  ${typography.bodyText}
  font-weight: 200;
`;

const CTA = styled(Button)`
  align-self: center;
  margin: ${size.md}px 0;
  ${mediaQueries.forTabletHorizontalUp} {
    margin-right: ${size.xl1}px;
  }
`;

const AddToCart: FC<AddToCart> = ({
  title,
  price,
  isUpgrade,
  slug,
  onClick,
}) => {
  const appearance = isUpgrade ? 'primary' : 'secondary';
  return (
    <>
      <ProductTitle to={`/products/${slug}`}>{title}</ProductTitle>
      <ProductPrice>${parseInt(price)}</ProductPrice>
      <CTA
        appearance={appearance}
        onClick={onClick}
        data-testid={`add-to-cart-${isUpgrade ? 'upgrade' : 'non-upgrade'}`}
      >
        Add to Cart
      </CTA>
    </>
  );
};

export default AddToCart;
